import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
} from "./../../components/card/card.jsx";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext.jsx";
import { toast } from "react-toastify";
import {
  machineProfile,
  asset,
  workOrder,
  inventory,
} from "../../api/index.js";
import { QRCode } from "react-qrcode-logo";
import LoadingIndicator from "../../components/LoadingIndicator/index.jsx";
import {
  renderImage,
  printLocation,
  Loader,
  formatDateOnly,
  getStatusColor,
  formatDateFull,
} from "../../utils/helper.jsx";
import { format } from "date-fns";
import ImageViewer from "../../components/ImageViewer";
import DataTable from "react-data-table-component";
import ConfirmationDlg from "../../components/ConfirmationDlg/index.jsx";
import WorkOrderTab from "./tabs/WorkOrderTab.jsx";
import RequestTab from "./tabs/RequestTab.jsx";

const printDate = (date) => {
  if (Object.prototype.toString.call(date) === "[object Date]") {
    // it is a date
    if (isNaN(date)) {
      // d.getTime() or d.valueOf() will also work
      return "-";
    } else {
      // date object is valid
    }
  } else {
    return "-";
  }
  if (!date) return "-";
  const dateSplit = date.split("-");
  const day = dateSplit[0] ? dateSplit[0] : "";
  const month = dateSplit[1]
    ? format(new Date().setMonth(dateSplit[1] - 1), "MMMM")
    : "";
  const year = dateSplit[2] ? dateSplit[2] : "";
  return day + " " + month + " " + year;
};

function PageAssetProfile({ assetId }) {
  let { id } = useParams();
  if (!id) id = assetId;
  const { hash } = useLocation();
  const { config, isHiddenFeature, getLocationName } = useAuth();
  const [attachments, setAttachments] = useState([]);
  const roleItem = config?.RoleCompanyMaster[0]?.feature_access;
  const woExist = roleItem?.find((item) => item === "Work Order Overview");
  const [openModal, setOpenModal] = React.useState(false);
  const defaultMenu = hash
    ? hash.replace("#", "")
    : !isHiddenFeature("machine_health")
    ? "machinehealth"
    : "sensor";
  const [selectedAsset, setSelectedAsset] = useState();
  const navigate = useNavigate();
  const [picture, setPicture] = useState(null);
  const [selectedFile, setSelectedFile] = useState();
  const location = useLocation();
  const [documents, setDocuments] = useState([]);
  const [docName, setDocName] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [subNavMenus, setSubNavMenus] = useState([]);
  const [activeMenu, setActiveMenu] = useState(defaultMenu);
  const [loading, setLoading] = useState(false);
  const [loadingWo, setLoadingWo] = useState(false);
  const [loadingRequestWo, setLoadingRequestWo] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);
  const [woQuery, setWoQuery] = useState({ page: 1, take: 10, totalData: 1 });
  const [requestWoQuery, setRequestWoQuery] = useState({
    page: 1,
    take: 10,
    totalData: 1,
  });
  const [woDatas, setWoDatas] = useState([]);
  const [requestWoDatas, setRequestWoDatas] = useState([]);
  const [locations, setLocations] = useState([]);
  const getAsset = async () => {
    try {
      setLoading(true);
      const res = await asset.getOne(id);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        setSelectedAsset(data);
        const att = [];
        if (data.attachments) {
          Object.keys(data.attachments).forEach((key) => {
            if (data.attachments[key]) {
              const name = key.split("_")[3];
              const type = key.split("_")[2];
              const isRequest = key.split("_")[0] !== "workoder";
              const url = renderImage(
                `machine/attachment/${data.attachments[key]}`
              );
              const attachment = {
                name: name,
                type,
                url,
                value: data.attachments[key],
              };
              att.push(attachment);
              // if (!isRequest) {
              //
              // }else{
              //   attReq.push(attachment)
              // }
            }
          });
          setAttachments(att);
        }
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    //console.log("fetching wave");
    getAsset();
  }, [id]);

  useEffect(() => {
    if (selectedAsset) {
      const locationName = [];
      function generateLocation(location) {
        locationName.push(location.location_name);
        if (location.parent_location) {
          generateLocation(location.parent_location);
        }
      }

      generateLocation(selectedAsset.location);
      setLocations(locationName.reverse());
    }
  }, [selectedAsset]);
  function isActive(item) {
    return item === activeMenu;
  }

  useEffect(() => {
    if (!selectedFile) {
      setPicture(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(selectedFile);
    setPicture(objectUrl);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  function hideConfirmationDialog() {
    setDeleteRow(null);
  }

  return (
    <div>
      <LoadingIndicator open={loading} />
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">ASSET</li>
            <li className="breadcrumb-item active">ASSET DETAIL</li>
          </ol>
          <h1 className="page-header mb-0">Asset Detail</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-4">
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Asset Information
            </CardHeader>
            <CardBody>
              <div className="row">
                <div className="col-lg-12 col-sm-12 mb-2">
                  <Card>
                    <CardBody style={{ padding: "7px" }}>
                      <ImageViewer src={selectedAsset?.asset_image} />
                    </CardBody>
                    <CardFooter className="text-theme fw-bold text-center">
                      {selectedAsset?.asset_name}
                    </CardFooter>
                  </Card>
                </div>
                <div className="col-lg-12 col-sm-12">
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Asset Category</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {selectedAsset?.category?.name}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />

                    <div className="d-flex">
                        <div className="flex-1 d-flex">
                            <div>Asset Model</div>
                            <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {selectedAsset?.asset_model}
                      </span>
                        </div>
                    </div>
                    <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Serial Number</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {selectedAsset?.serial_number}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Description</div>
                      <span
                        style={{ textAlign: "right" }}
                        className="texh-right text-theme fw-bold fs-12px ms-auto me-2"
                      >
                        {selectedAsset?.description}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Ownership</div>
                      <span
                        style={{ textAlign: "right" }}
                        className="texh-right text-theme fw-bold fs-12px ms-auto me-2"
                      >
                        {selectedAsset?.customer_id &&
                          selectedAsset.customer.customer_name}
                        {selectedAsset?.user_id &&
                          selectedAsset.user.firstname +
                            " " +
                            selectedAsset.user.lastname}
                        {selectedAsset?.team_id && selectedAsset.team.team_name}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Asset Location
            </CardHeader>
            <CardBody className="card-body pb-2">
              {locations.map((l, index) => {
                return (
                  <div key={index}>
                    <div className="d-flex">
                      <div className="flex-1 d-flex">
                        <div> {getLocationName(index)}</div>
                        <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                          {printLocation(l)}
                        </span>
                      </div>
                    </div>
                    <hr style={{ margin: "0.3rem 0" }} />
                  </div>
                );
              })}
            </CardBody>
          </Card>
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Asset QR Code
            </CardHeader>
            <CardBody className="card-body pb-2 text-center">
              <QRCode
                value={selectedAsset?.barcode}
                logoImage={"/cmms/logo.png"}
              />
            </CardBody>
          </Card>
          {attachments.length > 0 ? (
            <div className="mb-3">
              <Card>
                <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
                  Attachments
                </CardHeader>
                <CardBody>
                  <div class="row">
                    {attachments.map((attachment, index) => (
                      <div key={index} className={"col-md-6 position-relative"}>
                        {attachment.type === "image" && (
                          <ImageViewer
                            staticImage={attachment.url}
                            className={"img-fluid w-100"}
                            alt=""
                          />
                        )}
                        {attachment.type === "video" && (
                          <video
                            src={attachment.url}
                            className={"img-fluid w-100"}
                            width={"100%"}
                            controls
                          />
                        )}
                        {attachment.type === "pdf" && (
                          <iframe
                            src={attachment.url}
                            className={" w-100"}
                            width={"100%"}
                            height={"350px"}
                          />
                        )}
                        {attachment.type === "other" && (
                          <a
                            href={attachment.url}
                            target={"_blank"}
                            rel="noreferrer"
                            style={{
                              height: "200px",
                              paddingTop: "95px",
                              display: "block",
                            }}
                            className={
                              "border-theme border-1 border w-100 text-center"
                            }
                          >
                            Download the File
                          </a>
                        )}

                        <div className="my-2">
                          <input
                            type="text"
                            className={"form-control"}
                            value={attachment.name}
                            readOnly
                            disabled
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </CardBody>
              </Card>
            </div>
          ) : null}
        </div>
        <div className="col-lg-8">
          <Card className="mb-4">
            <CardBody>
              <ul className="nav nav-tabs">
                <li className="nav-item me-1">
                  <a
                    href="#home"
                    className="nav-link active"
                    data-bs-toggle="tab"
                  >
                    Work Order
                  </a>
                </li>

                <li className="nav-item me-1">
                  <a href="#request" className="nav-link" data-bs-toggle="tab">
                    Request
                  </a>
                </li>

                <li className="nav-item me-1">
                  <a
                    href="#parts"
                    className={`nav-link ${
                      isHiddenFeature("machine_health") ? "active" : ""
                    }`}
                    data-bs-toggle="tab"
                  >
                    Parts Histories
                  </a>
                </li>
                <li className="nav-item me-1">
                  <a
                    href="#subs"
                    className={`nav-link ${
                      isHiddenFeature("machine_health") ? "active" : ""
                    }`}
                    data-bs-toggle="tab"
                  >
                    Sub Asset
                  </a>
                </li>
                <li className="nav-item me-1">
                  <a
                    href="#movement"
                    className={`nav-link ${
                      isHiddenFeature("machine_health") ? "active" : ""
                    }`}
                    data-bs-toggle="tab"
                  >
                    Movement Histories
                  </a>
                </li>
                {/* <li className="nav-item me-1">
                  <a href="#success" className="nav-link" data-bs-toggle="tab">
                    Meter
                  </a>
                </li> */}
                {/*<li className="nav-item me-1">*/}
                {/*  <a href="#wo" className="nav-link" data-bs-toggle="tab">*/}
                {/*    Work Order Schedule*/}
                {/*  </a>*/}
                {/*</li>*/}
              </ul>
              <div className="tab-content pt-3">
                <div className="tab-pane fade show active" id="home">
                  <WorkOrderTab assetId={id} />
                </div>

                <div className="tab-pane fade" id="request">
                  <RequestTab assetId={id} />
                </div>

                <div className="tab-pane fade" id="subs">
                  {selectedAsset?.asset_components?.map((wo, indexWo) => {
                    return (
                      <Card style={{ marginBottom: "20px" }} key={indexWo}>
                        <CardHeader>{wo.component}</CardHeader>
                        <CardBody>
                          <table
                            className={"table table-striped table-responsive"}
                          >
                            <thead>
                              <tr>
                                <th>Title</th>
                                <th>Priority</th>
                                <th>Status</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {wo.WorkOrder.map((inventory, indexInventory) => {
                                return (
                                  <tr key={indexInventory}>
                                    <td> {inventory.title}</td>
                                    <td> {inventory.priority}</td>
                                    <td> {inventory.status}</td>
                                    <td>
                                      <a
                                        href={
                                          `/work-order/detail/` + inventory.id
                                        }
                                      >
                                        View Detail
                                      </a>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>

                          {wo.WorkOrder.length == 0
                            ? "- There is no Work Order -"
                            : null}
                        </CardBody>
                      </Card>
                    );
                  })}
                </div>
                <div className="tab-pane fade" id="parts">
                  {selectedAsset?.work_orders.map((wo, indexWo) => {
                    return (
                      <Card style={{ marginBottom: "20px" }} key={indexWo}>
                        <CardHeader>{wo.title}</CardHeader>
                        <CardBody>
                          {wo.inventories.map((inventory, indexInventory) => {
                            return (
                              <div key={indexInventory}>
                                {inventory.inventory.part.part_name} :{" "}
                                {inventory.quantity}
                              </div>
                            );
                          })}
                          {wo.inventories.length == 0
                            ? "- There is no part used -"
                            : null}
                        </CardBody>
                      </Card>
                    );
                  })}
                </div>

                <div className="tab-pane fade" id="movement">
                  {selectedAsset?.changeLogs.map((log, indexWo) => {
                    return (
                      <Card style={{ marginBottom: "20px" }} key={indexWo}>
                        <CardHeader style={{ textTransform: "capitalize" }}>
                          {log.type} Change
                        </CardHeader>
                        <CardBody>
                          <b>
                            {log.old_value}{" "}
                            <span className="fa fa-arrow-right"></span>{" "}
                            {log.new_value}
                          </b>{" "}
                          at <i>{formatDateFull(log.created_at)}</i>
                        </CardBody>
                      </Card>
                    );
                  })}
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default PageAssetProfile;
